var React = require('react');
var PropTypes = require('prop-types');
var lodash = require('lodash').noConflict();
var labels = require('MemberJoinLabels');
var dataService = require('./ReactDependencies/memberJoinDataService.jsx');
var accountDataService = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx');
var stepSchema = require('../../../../Scripts/React/memberJoinStepSchema.jsx');
var postSchema = require('./ReactDependencies/memberJoinPostSchemas.jsx');
var modalInfo = require('MemberJoinFieldInfo');
var StateDebugger = require('./ReactDependencies/stateDebugger.jsx');
var ToggleDebugger = require('./ReactDependencies/toggleDebugger.jsx');
var ProgressBar = require('../ProgressBar/progressBar.jsx');
var Cart = require('./ReactDependencies/cart.jsx');
var { setStepDataFromApi } = require('./ReactDependencies/setStepDataFromApi.jsx');

var apiDataRepository = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableApiData.jsx');
var selectableDataRepository = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableData.jsx');

var Step0 = require('../Step0/step0.jsx');
var Step1 = require('../Step1/step1.jsx');
var Step2 = require('../Step2/step2.jsx');
var Step3 = require('../Step3/step3.jsx');
var Step4 = require('../Step4/step4.jsx');
var Step5 = require('../Step5/step5.jsx');
var Step6 = require('../Step6/step6.jsx');

class MembershipApplication extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            debugMode: false,
            disableUI: true,
            currentStep: this.props.currentStep,
            membershipPrice: 0,
            stateParticipating: false,
            stateComponentDues: 0,
            districtDues:0,
            stateComponentDuesOptOut: false,
            stateComponentDuesOptOutEligible: false,
            MemberProductTitleLongName: '',
            primaryPracticeLocation: this.props.primaryPracticeLocation,
            primaryDistrictLocation: this.props.primaryDistrictLocation,
            yearsInPractice: this.props.yearsInPractice,
            appType: this.props.applicationType,
            productType: this.props.productType,
            rateType: this.props.rateType,
            rateCode: '',
            orderNumber: this.props.orderNumber,
            membershipStartDate: '',
            membershipEndDate: '',
            membershipProductTitleLongName: '',
            isMilitary: this.props.isMilitary,
            isGovernmentEmployee: this.props.isGovernmentEmployee,
            isInternational: this.props.applicationType && this.props.applicationType.indexOf('INT') === 0,
            isPdf: false,
            stepState: stepSchema,
            apiData: selectableDataRepository,
            firstName: this.props.FirstName,
            lastName: this.props.LastName,
            accountName: this.props.accountFullName,
            modalKey: '',
            userLoggedIn: this.props.accountFullName ? true : false,
            applicationCreated: this.props.applicationType ? true : false,
            stepProgress: this.props.currentStep,
            stepStateCache: {},
            stepPostCache: {}
        };

        this.stepComponents = {
            0: Step0,
            1: Step1,
            2: Step2,
            3: Step3,
            4: Step4,
            5: Step5,
            6: Step6
           
        };

        this.bindFunctions();
    }

    bindFunctions() {
        this.apiDataLoadIsSuccessful = this.apiDataLoadIsSuccessful.bind(this);
        this.apiResponseSuccess = this.apiResponseSuccess.bind(this);
        this.currentStepHasEdits = this.currentStepHasEdits.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.disableUI = this.disableUI.bind(this);
        this.dismissErrorModal = this.dismissErrorModal.bind(this);
        this.dismissInfoModal = this.dismissInfoModal.bind(this);
        this.enableUI = this.enableUI.bind(this);
        this.getCurrentStepComponent = this.getCurrentStepComponent.bind(this);
        this.getGreetingMarkup = this.getGreetingMarkup.bind(this);
        this.getOtherStepData = this.getOtherStepData.bind(this);
        this.getAppState = this.getAppState.bind(this);
        this.getDisabledClass = this.getDisabledClass.bind(this);
        this.getStepState = this.getStepState.bind(this);
        this.goPrevStep = this.goPrevStep.bind(this);
        this.goToStep = this.goToStep.bind(this);
        this.getStepDataFromApi = this.getStepDataFromApi.bind(this);
        this.handleStepChangeError = this.handleStepChangeError.bind(this);
        this.getPriceTotal = this.getPriceTotal.bind(this);
        this.getErrorModal = this.getErrorModal.bind(this);
        this.getInfoModal = this.getInfoModal.bind(this);
        this.getInfoModalContent = this.getInfoModalContent.bind(this);
        this.getMembershipModal = this.getMembershipModal.bind(this);
        this.getLoginInfoModal = this.getLoginInfoModal.bind(this);
        this.hasModalInfo = this.hasModalInfo.bind(this);
        this.loadApiData = this.loadApiData.bind(this);
        this.pushNewRecord = this.pushNewRecord.bind(this);
        this.recenterScreen = this.recenterScreen.bind(this);
        this.redirectOnSubmitSuccess = this.redirectOnSubmitSuccess.bind(this);
        this.saveAndExit = this.saveAndExit.bind(this);
        this.setErrorModalData = this.setErrorModalData.bind(this);
        this.setStepDataFromApi = setStepDataFromApi.bind(this);
        this.showErrorModal = this.showErrorModal.bind(this);
        this.showInfoModal = this.showInfoModal.bind(this);
        this.showLoginInfoModal = this.showLoginInfoModal.bind(this);
        this.showMembershipModal = this.showMembershipModal.bind(this);
        this.stepPostIsComplete = this.stepPostIsComplete.bind(this);
        this.submitApplication = this.submitApplication.bind(this);
        this.updateApplicationState = this.updateApplicationState.bind(this);
        this.updateComponentMarkup = this.updateComponentMarkup.bind(this);
        this.updateArbitraryStepState = this.updateArbitraryStepState.bind(this);
        this.updateStepState = this.updateStepState.bind(this);
        this.updateStepStateCache = this.updateStepStateCache.bind(this);
        this.updateStepStateMultiSelect = this.updateStepStateMultiSelect.bind(this);
        this.updateStepStateRecord = this.updateStepStateRecord.bind(this);
        this.dismissMembershipModal = this.dismissMembershipModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.dismissLoginInfoModal = this.dismissLoginInfoModal.bind(this);
    }

    disableUI() {
        this.setState({
            disableUI: true
        });
    }

    enableUI() {
        this.setState({
            disableUI: false
        });
    }

    getDisabledClass() {
        return this.state.disableUI ? 'ui-is-disabled' : '';
    }

    componentDidMount() {
        this.getStepDataFromApi(this.state.currentStep).then(this.enableUI, this.handleStepChangeError);
    }

    componentWillUnmount() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }

    loadApiData(dataKey, fetchOptions) {
        if (this.state.apiData[dataKey] && this.state.apiData[dataKey].length) {
            return;
        }

        if (apiDataRepository[dataKey]) {
            apiDataRepository[dataKey](fetchOptions)
                .then((result) => {
                    this.state.apiData[dataKey] = result;

                    this.setState({
                        apiData: this.state.apiData
                    });

                    // optional callback to trigger something back in the child that called loadApiData
                    if (fetchOptions && fetchOptions.stateTriggerFunc) {
                        fetchOptions.stateTriggerFunc();
                    }
                },
                    (error) => {
                        return [];
                    });
        }
    }

    apiDataLoadIsSuccessful(data) {
        return data.response && data.response.ResultStatus && data.response.ResultStatus.Success;
    }

    recenterScreen(target) {
        var scrollTo = $(target);

        if (scrollTo && scrollTo.length) {
            $('html, body').animate({ scrollTop: scrollTo.offset().top - 100 }, '50'); // account for header and padding
        }
    }

    getCurrentStepComponent() {

        return this.stepComponents[this.state.currentStep];
    }

    updateComponentMarkup(markupName, markup) {
        if (this.state.stepState[this.state.currentStep].componentMarkup) {
            this.state.stepState[this.state.currentStep].componentMarkup[markupName] = markup;

            this.setState({ stepState: this.state.stepState });
        }
    }

    updateStepStateMultiSelect(fieldName, value, isChecked) {
        if (isChecked) {
            this.state.stepState[this.state.currentStep][fieldName].push(value);
        } else {
            this.state.stepState[this.state.currentStep][fieldName] = lodash.remove(this.state.stepState[this.state.currentStep][fieldName], function (val) {
                return JSON.stringify(val) !== JSON.stringify(value);
            }.bind(this));
        }

        this.setState({ stepState: this.state.stepState });
    }

    updateStepState(fieldName, value, callback) {
        this.state.stepState[this.state.currentStep][fieldName] = value;
        this.setState({
            stepState: this.state.stepState
        }, callback);
    }

    updateArbitraryStepState(fieldName, value, step) {
        this.state.stepState[step][fieldName] = value;
        this.setState({
            stepState: this.state.stepState
        });
    }

    updateStepStateRecord(recordField, fieldToUpdate, value, recordId) {
        var recordToUpdate = lodash.find(this.state.stepState[this.state.currentStep][recordField], x => x.id == recordId);

        if (recordToUpdate) {
            recordToUpdate[fieldToUpdate] = value;

            this.setState({
                stepState: this.state.stepState
            });
        }
    }

    pushNewRecord(recordField, record) {
        this.state.stepState[this.state.currentStep][recordField].push(record);

        this.setState({
            stepState: this.state.stepState
        });
    }

    deleteRecord(recordField, recordId, recordIsLocalOnly) {
        var finalizeDelete = () => {
            var indexToDelete = lodash.findIndex(this.state.stepState[this.state.currentStep][recordField], x => x.id == recordId);

            if (indexToDelete >= 0) {
                this.state.stepState[this.state.currentStep][recordField].splice(indexToDelete, 1);

                this.setState({
                    stepState: this.state.stepState
                });
            }
        }

        if (recordIsLocalOnly) {
            finalizeDelete();
            return;
        }

        dataService.deleteStepData(this.state.currentStep, recordField, recordId).then(finalizeDelete.bind(this));
    }

    updateApplicationState(fieldName, value) {
        this.setState({
            [fieldName]: value
        });
    }

    getAppState() {

        return {
            userLoggedIn: this.state.userLoggedIn,
            debugMode: this.state.debugMode,
            currentStep: this.state.currentStep,
            disableUI: this.state.disableUI,
            membershipPrice: this.state.membershipPrice,
            stateParticipating: this.state.stateParticipating,
            stateComponentDues: this.state.stateComponentDues,
            stateComponentDuesOptOut: this.state.stateComponentDuesOptOut,
            stateComponentDuesOptOutEligible: this.state.stateComponentDuesOptOutEligible,
            districtDues: this.state.districtDues,
            districtParticipating: this.state.districtParticipating,
            districtProductTitle: this.state.districtProductTitle,
            priceTotal: this.getPriceTotal(),
            appType: this.state.appType,
            productType: this.state.productType,
            productId: this.state.productId,
            primaryPracticeLocation: this.state.primaryPracticeLocation,
            primaryDistrictLocation: this.state.primaryDistrictLocation,
            yearsInPractice: this.state.yearsInPractice,
            rateType: this.state.rateType,
            rateCode: this.state.rateCode,
            orderNumber: this.state.orderNumber,
            membershipStartDate: this.state.membershipStartDate,
            membershipEndDate: this.state.membershipEndDate,
            membershipProductTitleLongName: this.state.membershipProductTitleLongName,
            isMilitary: this.state.isMilitary,
            isGovernmentEmployee: this.state.isGovernmentEmployee,
            isInternational: this.state.isInternational,
            isPdf: this.state.isPdf,
            apiData: this.state.apiData,
            stepProgress: this.state.stepProgress,
            applicationCreated: this.state.applicationCreated
        }
    }

    getStepState(step) {
        return step ? this.state.stepState[step] : this.state.stepState[this.state.currentStep];

    }

    getOtherStepData(step, field) {
        return this.state.stepState[step][field];
    }

    getPriceTotal() {
        var stateDues = this.state.stateComponentDuesOptOut ? 0 : (isNaN(this.state.stateComponentDues) ? 0 : this.state.stateComponentDues);
        var districtDues = this.state.stateComponentDuesOptOut ? 0 : (isNaN(this.state.districtDues) ? 0 : this.state.districtDues);
        var membershipPrice = isNaN(this.state.membershipPrice) ? 0 : this.state.membershipPrice;

        var total = stateDues + districtDues + membershipPrice; 
        return total;
    }

    getStepDataFromApi(step) {
        return new Promise(function (resolve, reject) {
            var resolver = (data) => {
                var rejectData = false;
                data.map((result) => {
                    // only checking if the server was able to send us something back
                    // if the user hasnt submitted anything for these fields yet, then the response will be empty
                    // so we can't really tell if it was a success
                    if (result && result.response) {

                        for (var apiResponseKey in result.response) {

                            if (dataService.apiResponseKeys[step] &&
                                dataService.apiResponseKeys[step].includes(apiResponseKey)) {
                                //console.log("setStep  " + step + " apiResponseKey " + apiResponseKey + " result.response[apiResponseKey] " + result.response[apiResponseKey]);
                                if (step == 6 && apiResponseKey == 'CustomerInformation' && result.response[apiResponseKey] && result.response[apiResponseKey][0].YearsInPractice) {
                                    var cusInfoRes = result.response[apiResponseKey][0];
                                    var yip = cusInfoRes.YearsInPractice
                                    console.log("YIP " + yip)
                                }

                                this.setStepDataFromApi(step, apiResponseKey, result.response[apiResponseKey]);
                            }



                        }

                        this.updateStepStateCache();

                    } else {

                        rejectData = true;
                    }
                });

                if (rejectData) {

                    reject(data);
                } else {

                    resolve(data);
                }
            };

            var userData = {
                productType: this.state.productType,
                rateType: this.state.rateType,
                primaryPracticeLocation: this.state.primaryPracticeLocation,
                primaryDistrictLocation: this.state.primaryDistrictLocation,
                yearsInPractice: this.state.yearsInPractice

            }
            // console.log("getStepDataFromAPI before getStep" + JSON.stringify(userData));

            return dataService.getStepData(step, userData).then(resolver, (errorData) => reject(errorData));
        }.bind(this));
    }

    apiResponseSuccess(resolveData) {
        // if resolveData is an empty array, then no data had to get posted during step change
        if (resolveData && resolveData.length === 0) {
            return true;
        }

        var isValidResponse = true;

        if (resolveData && resolveData.length) {
            resolveData.forEach((result) => {
                if (!(result && result.response === true) && !(result && result.response && result.response.ResultStatus && result.response.ResultStatus.Success)) {
                    isValidResponse = false;
                }
            });
        } else {
            if (!(resolveData && resolveData.response === true) && !(resolveData && resolveData.response && resolveData.response.ResultStatus && resolveData.response.ResultStatus.Success)) {
                isValidResponse = false;
            }
        }
        return isValidResponse;
    }

    stepPostIsComplete(promiseData, changingToStep) {
        return new Promise(function (resolve, reject) {
            if (this.apiResponseSuccess(promiseData)) {
                resolve(changingToStep);
            } else {
                reject(promiseData);
            }
        }.bind(this));
    }

    handleStepChangeError(errorData) {
        var errorStrings = [];

        if (errorData && errorData.length) {
            errorStrings = errorData.filter((error) => {
                return error && error.response && error.response.PersonifyErrors && error.response.PersonifyErrors.Errors && error.response.PersonifyErrors.Errors.length;
            }).map((error) => {
                return error.response.PersonifyErrors.Errors.map((errorString) => {
                    return errorString;
                });
            });
        } else {
            if (errorData && errorData.response && errorData.response.PersonifyErrors && errorData.response.PersonifyErrors.Errors && errorData.response.PersonifyErrors.Errors.length) {
                errorStrings = [errorData.response.PersonifyErrors.Errors[0]];
            }
        }

        this.setErrorModalData(errorStrings.join('  '));

        this.enableUI();
        this.showErrorModal();
    }

    goToStep(event, step, stepCleanupFunc) {
        event.preventDefault();
        this.disableUI();

        var finalizeStepChange = function (responseData) {

            this.updateStepStateCache();
            this.setState(prevState => ({
                currentStep: step
            }),
                () => {
                    if (this.state.currentStep > this.state.stepProgress) {
                        this.setState({
                            stepProgress: this.state.currentStep
                        });
                    }

                    this.recenterScreen('.progress-bar');

                    var postCacheUpdateCallback = () => {
                        if (stepCleanupFunc) {
                            stepCleanupFunc(responseData);
                        }
                    };

                    this.updateStepStateCache(postCacheUpdateCallback);

                    this.enableUI();
                });
        }.bind(this);

        if (this.currentStepHasEdits() && this.state.currentStep !== 6) {
            var postData = {
                appState: this.getAppState(),
                stepState: this.getStepState()
            };

            dataService.submitStepData(this.state.currentStep, postData, this.state.stepPostCache)
                .then((resolveData) => this.stepPostIsComplete(resolveData, step).then(() => this.getStepDataFromApi(step).then(finalizeStepChange, this.handleStepChangeError)
                    , (resolveData) => this.handleStepChangeError(resolveData)));

        } else {
            this.getStepDataFromApi(step).then(finalizeStepChange, this.handleStepChangeError);
        }
    }

    redirectOnSubmitSuccess(orderResponse) {
        // redirect them to thank you page with querystring param "OrderNumber"
        window.location = window.location.origin + "/Member-Join-Invoice/#/invoicepay/" + orderResponse.InvoiceId +"/mj";
           
    }

    submitApplication(event) {
        event.preventDefault();

        if (this._submittingPayment) {
            return;
        }
        this._submittingPayment = true;

        const finalizeAppSubmission = (resolveData) => {
            if (resolveData && resolveData.length && resolveData[0].response) {
                var orderResponse = JSON.parse(resolveData[0].response);
                //var orderResponse = JSON.parse(resolveData[3].response);

                var invoiceIsValid = orderResponse.InvoiceId != null
                    && orderResponse.InvoiceId !== '00000000-0000-0000-0000-000000000000';

                if (orderResponse.ResultStatus && orderResponse.ResultStatus.Success == true && invoiceIsValid) {
                    // Success → page navigates away; intentionally leave the guard set so any
                    // late clicks before navigation completes are ignored.
                    this.redirectOnSubmitSuccess(orderResponse);
                    return;
                }

                var serverErrors = orderResponse.ResultStatus && orderResponse.ResultStatus.Errors;
                var errorMessage = (serverErrors && serverErrors.length)
                    ? serverErrors.join(' ')
                    : 'Please submit again. If the issue continues, our support team can help via the Live Chat / Get Help tab anytime or call (630) 912 2552, M-F, 7:30 a.m.–4:30 p.m. CT.';

                this.setErrorModalData(errorMessage, 'We couldn’t process your application');

                this._submittingPayment = false;
                this.enableUI();
                this.showErrorModal();
            } else {
                this._submittingPayment = false;
                this.handleStepChangeError(resolveData);
            }
        }

        this.disableUI();

        var postApplicationData = () => {
            var postData = {
                appState: this.getAppState(),
                stepState: this.getStepState()
            };

            dataService.submitStepData(this.state.currentStep, postData, this.state.stepPostCache).then(
                (resolveData) => finalizeAppSubmission(resolveData),
                (rejectData) => {
                    this._submittingPayment = false;
                    this.handleStepChangeError(rejectData);
                }
            );
        }

        postApplicationData();

    }

    updateStepStateCache(postCacheUpdateCallback) {
        var currentState = lodash.cloneDeep(this.getStepState());
        if (currentState && currentState.componentMarkup) {
            delete currentState.componentMarkup; // dont care about markup changes
        }
        this.state.stepStateCache[this.state.currentStep] = JSON.stringify(currentState);
        this.state.stepPostCache[this.state.currentStep] = {};

        for (var prop in postSchema[this.state.currentStep]) {
            this.state.stepPostCache[this.state.currentStep][prop] = postSchema[this.state.currentStep][prop]({
                appState: this.getAppState(),
                stepState: this.getStepState()
            });
        }

        this.setState(
            {
                stepStateCache: this.state.stepStateCache,
                stepPostCache: this.state.stepPostCache
            },
            postCacheUpdateCallback
        );
    }

    currentStepHasEdits() {
        var old = this.state.stepStateCache[this.state.currentStep];

        if (old) {
            var current = lodash.cloneDeep(this.getStepState());
            if (current && current.componentMarkup) {
                delete current.componentMarkup;
            }

            return JSON.stringify(current) !== old;
        } else {
            return true;
        }
    }

    goPrevStep() {
        this.setState(prevState => ({
            currentStep: prevState.currentStep - 1
        }), () => this.recenterScreen('.progress-bar'));
    }

    getGreetingMarkup() {
        if (this.state.accountName) {
            //const creds = this.getOtherStepData(2, 'credentials').join(', ');
            return <h2>{labels.hello} {this.state.accountName}</h2>;
        }
    }

    hasModalInfo(modalKey) {
        // exists if modal key exists and application field is empty string (must check empty string, falsey isnt enough)
        // or modal key exists and application type equal to the current application type
        return (modalInfo[this.state.currentStep][modalKey] && modalInfo[this.state.currentStep][modalKey].applicationType === '')
            || (modalInfo[this.state.currentStep][modalKey] && modalInfo[this.state.currentStep][modalKey][this.state.appType]);
    }

    getInfoModalContent(modalKey) {
        if (modalInfo[this.state.currentStep][modalKey] && (modalInfo[this.state.currentStep][modalKey][this.state.appType])) {
            return modalInfo[this.state.currentStep][modalKey][this.state.appType];
        }

        if (modalInfo[this.state.currentStep][modalKey] && !modalInfo[this.state.currentStep][modalKey].applicationType) {
            return modalInfo[this.state.currentStep][modalKey];
        }
    }

    getInfoModal() {
        let title = '', description = '';
        if (this.state.modalKey) {
            var modalInfo = this.getInfoModalContent(this.state.modalKey);
            if (modalInfo) {
                title = modalInfo.title;
                description = modalInfo.description;
            }
        }
        return this.getModalMarkup('infoModal', title, description, this.dismissInfoModal);
    }

    getErrorModal() {
        let title = '', description = '';
        if (this.state.errorInfo) {
            title = this.state.errorInfo.title;
            description = this.state.errorInfo.description;
        }

        return this.getModalMarkup('errorModal', title, description, this.dismissErrorModal);
    }

    getMembershipModal() {
        let title = '', description = '';
        var modalInfo = this.getInfoModalContent(labels.earlyCareer.modalKey);

        if (modalInfo) {
            title = modalInfo.title;
            description = modalInfo.description;
        }

        return this.getModalMarkup('membershipModal', title, description, this.dismissMembershipModal);
    }

    getModalMarkup(id, title, description, dismissFunction) {
        let modalCss = 'modal-dialog modal-dialog-centered ';
        if (this.state.modalKey.endsWith('districtinfo')) {
            modalCss += 'modal-lg';
        }
        return <div className={"basemodal modal fade"} id={id} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className={modalCss} role="document">
                <div className={"modal-content"}>
                    <div className={"modal-header"}>
                        <a href="#" className={"close"} data-dismiss="modal" aria-label="Close">
                            <img src="../../../../../Images/base/dist/icon-close.svg" alt="" />
                        </a>
                    </div>
                    <div className={"modal-body"}>
                        <h3>{title}</h3>
                        <p dangerouslySetInnerHTML={{ __html: description }}></p>
                    </div>
                    <div className={"modal-footer"}>
                        <a href="#" className={"cta cancel"} onClick={dismissFunction} data-dismiss="modal">OK</a>
                    </div>
                </div>
            </div>
        </div>;
    }


    getLoginModalMarkup(id, title, description, dismissFunction) {
        let modalCss = 'modal-dialog modal-dialog-centered ';
        if (this.state.modalKey.endsWith('districtinfo')) {
            modalCss += 'modal-lg';
        }
        return <div className={"basemodal modal fade"} id={id} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className={modalCss} role="document">
                <div className={"modal-content"}>
                    <div className={"modal-body"}>
                        <h3>{title}</h3>
                        <p dangerouslySetInnerHTML={{ __html: description }}></p>
                    </div>
                    <div className={"modal-footer"} style={{ justifyContent: 'center' }}>
                        <strong>{this.state.countdown || 5}{this.state.countdownDots || '.'}</strong>
                    </div>
                </div>
            </div>
        </div>;
    }

    getLoginInfoModal() {
        let title = '', description = '';
        if (this.state.modalKey) {
            var modalInfo = this.getInfoModalContent(this.state.modalKey);
            if (modalInfo) {
                title = modalInfo.title;
                description = modalInfo.description;
            }
        }

        return this.getLoginModalMarkup('logininfoModal', title, description, this.dismissLoginInfoModal);
    }

    handleLogin() {
        window.location = window.location.origin + "/member-center/login?returnurl=/member-join";

    }

    dismissLoginInfoModal() {
       window.location = window.location.origin;  
    }


    showLoginInfoModal(key) {
        this.setState({
            modalKey: key,
            countdown: 5, 
            countdownDots: '.' 
        });

        $('#logininfoModal').modal('show');

        $('#logininfoModal').on('shown.bs.modal', () => {
            this.startCountdown();
        });

        $('#logininfoModal').on('hidden.bs.modal', () => this.handleLogin());
    }

    startCountdown() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }

        let dotCount = 1;

        this.countdownInterval = setInterval(() => {
            this.setState(prevState => {
                const dots = '.'.repeat((dotCount % 3) + 1);
                dotCount++;

                if (dotCount % 4 === 1 && prevState.countdown > 0) {
                    const newCountdown = prevState.countdown - 1;

                    if (newCountdown === 0) {
                        setTimeout(() => {
                            clearInterval(this.countdownInterval);
                            this.handleLogin();
                        }, 1000);

                        return { countdown: "Redirecting", countdownDots: '...' };
                    }

                    return { countdown: newCountdown, countdownDots: dots };
                }

                return { ...prevState, countdownDots: dots };
            });
        }, 333);
    }

    showInfoModal(key) {
        this.setState({
            modalKey: key
        });

        $('#infoModal').modal('show');
        $('#infoModal').on('hidden.bs.modal', () => this.dismissInfoModal());
    }

    showErrorModal() {
        $('#errorModal').modal('show');
        $('#errorModal').on('hidden.bs.modal', () => this.dismissErrorModal());
    }

    showMembershipModal() {
        $('#membershipModal').modal('show');
        $('#membershipModal').on('hidden.bs.modal', () => this.dismissMembershipModal);
    }

    setErrorModalData(errorString, errorTitle) {
        var errorLabel = errorString ? errorString : '';
        this.setState({
            errorInfo: {
                title: errorTitle || labels.anErrorOccured,
                description: errorLabel
            }
        });
    }

    dismissErrorModal() {
        this.setState({
            errorInfo: null
        });

        $('#errorModal').modal('hide');
    }

    dismissInfoModal() {
        this.setState({
            modalKey: ''
        });

        $('#infoModal').modal('hide');
    }

 
    dismissMembershipModal() {
        $('#membershipModal').modal('hide');
    }

    saveAndExit(event) {
        event.preventDefault();
        var postData = {
            appState: this.getAppState(),
            stepState: this.getStepState()
        };

        var exit = () => {
            window.location = window.location.origin;
        }

        dataService.submitStepData(this.state.currentStep, postData, this.state.stepPostCache).then(exit, this.handleStepChangeError);
    }

    render() {
        const cart = <Cart appState={this.getAppState()} updateApplicationState={this.updateApplicationState} saveAndExit={this.saveAndExit} />;
        const StepComponent = this.getCurrentStepComponent();
        const $stepComponent = StepComponent ?
            <StepComponent updateApplicationState={this.updateApplicationState}
                updateComponentMarkup={this.updateComponentMarkup}
                updateStepState={this.updateStepState}
                updateArbitraryStepState={this.updateArbitraryStepState}
                updateStepStateMultiSelect={this.updateStepStateMultiSelect}
                updateStepStateRecord={this.updateStepStateRecord}
                pushNewRecord={this.pushNewRecord}
                deleteRecord={this.deleteRecord}
                getOtherStepData={this.getOtherStepData}
                goToStep={this.goToStep}
                goPrevStep={this.goPrevStep}
                submitApplication={this.submitApplication}
                loadApiData={this.loadApiData}
                recenterScreen={this.recenterScreen}
                showInfoModal={this.showInfoModal}
                showLoginInfoModal={this.showLoginInfoModal }
                filterRepositoryData={this.filterRepositoryData}
                getStepState={this.getStepState}
                stepState={this.getStepState()}
                appState={this.getAppState()}
                apiData={this.state.apiData}
                modalInfo={modalInfo}
                hasModalInfo={this.hasModalInfo}
                cartComponent={cart}
                enableUI={this.enableUI}
                disableUI={this.disableUI}
                getInfoModalContent={this.getInfoModalContent}
                setErrorModalData={this.setErrorModalData}
                showErrorModal={this.showErrorModal}
                getMembershipModal={this.getMembershipModal}
                getLoginInfoModal={this.getLoginInfoModal}
                handleLogin={this.handleLogin }
                showMembershipModal={this.showMembershipModal} /> : null;

        const infoModal = this.getInfoModal();
        const errorModal = this.getErrorModal();
        const membershipModal = this.getMembershipModal();
        const loginModal = this.getLoginInfoModal();

        return <div className={"member-application " + this.getDisabledClass()}>

            <h1>{labels.applicationTitle}</h1>

            <ProgressBar appState={this.getAppState()} goToStep={this.goToStep} />

            <div className={"step-container"}>
                {this.getGreetingMarkup()}
                {$stepComponent}
            </div>
            {infoModal}
            {errorModal}
            {membershipModal}
            {loginModal }
        </div>;
    }
}

MembershipApplication.propTypes = {
    appType: PropTypes.string,
    isMilitary: PropTypes.bool,
    isGovernmentEmployee: PropTypes.bool,
    firstName: PropTypes.string,
    lastName: PropTypes.string
};

MembershipApplication.defaultProps = {
    appType: '',
    isMilitary: false,
    isGovernmentEmployee: false,
    firstName: '',
    lastName: ''
};

module.exports = MembershipApplication;
